module.exports = __webpack_public_path__ + "static/home-slideshow-02-638ebc563df6f04b5a0495c7453b902f.jpg";